import SectionLabel from "@/components/base/SectionLabel";
import { pricingData } from "@/mocks/pricingData";

export default function PriceFactorsSection() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-8">
        <div className="text-center mb-10 md:mb-14 reveal">
          <SectionLabel label={pricingData.priceFactors.label} className="mb-3" />
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 mb-4">
            {pricingData.priceFactors.title}
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            {pricingData.priceFactors.intro}
          </p>
        </div>

        <div className="reveal grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4 max-w-4xl mx-auto">
          {pricingData.priceFactors.items.map((item, i) => (
            <div
              key={i}
              className="flex items-center gap-3 p-3.5 md:p-4 rounded-md bg-background-100 border border-background-200/70"
            >
              <div className="w-8 h-8 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                <i className={`${item.icon} text-primary-600 text-sm`} />
              </div>
              <span className="text-sm md:text-base text-foreground-700">{item.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}